module.exports = __webpack_public_path__ + "53122635b28a2fbd4db957b59232c5c4.jpg";